import { render, staticRenderFns } from "./LinkCard.vue?vue&type=template&id=502ee4c9&scoped=true&"
import script from "./LinkCard.vue?vue&type=script&lang=js&"
export * from "./LinkCard.vue?vue&type=script&lang=js&"
import style0 from "./LinkCard.vue?vue&type=style&index=0&id=502ee4c9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502ee4c9",
  null
  
)

export default component.exports